import { Observable, timer } from 'rxjs';
import { delayWhen, map, retryWhen } from 'rxjs/operators';

export function delayedResponseRetry(successObject: any, scalingDelay: number, maxRetryAttempts?: number) {
    let retryAttempt = 0;
    return (src: Observable<any>) =>
        src.pipe(
            map((val) => {
                retryAttempt += 1;

                if (JSON.stringify(val) === JSON.stringify(successObject)) {
                    return val;
                } else {
                    throw retryAttempt;
                }
            }),
            retryWhen((errors) =>
                errors.pipe(
                    delayWhen((retryAttempt) => {
                        if (retryAttempt.status) {
                            throw retryAttempt;
                        } else {
                            if (maxRetryAttempts && retryAttempt >= maxRetryAttempts) {
                                const error: Error = {
                                    name: 'delayedResponseRetryError',
                                    message: 'MAX_RETRY_ATTEMPT_EXCEEDED',
                                };
                                throw error;
                            } else {
                                return timer(retryAttempt * scalingDelay);
                            }
                        }
                    })
                )
            )
        );
}
